import { HttpContextToken } from "@angular/common/http";

/**
 * SAN-1041 — set on background/widget requests whose 403 is an expected
 * business state (e.g. "Startup profile is not approved"), so the global
 * 403 handler in AddTokenHeaderHttpRequestInterceptor doesn't toast +
 * navigate('/') for them. That redirect re-triggered the caller on the next
 * render and produced a tight request -> 403 -> navigate -> request loop
 * (41 events in ~1s).
 */
export const SKIP_FORBIDDEN_REDIRECT = new HttpContextToken<boolean>(() => false);

/**
 * SAN-1729 — set on background tracking requests (notification-centre
 * item views / section visits). They fire on public pages such as
 * /programs/apply/:code/:slug, where a logged-out visitor legitimately has
 * no session; their 401 must not trigger the global "session expired"
 * storage clear + logout + redirect to /auth/login.
 */
export const SKIP_UNAUTHORIZED_REDIRECT = new HttpContextToken<boolean>(() => false);
